export const getEnvVar = (key: keyof NodeJS.ProcessEnv): string => {
  const value = process.env[key];
  if (!value) {
    console.warn(`Environment variable ${key} is not defined`);
  }
  return value ?? "";
};

export const API_BACKEND_URL = getEnvVar("REACT_APP_API_BACKEND_URL");
export const ENV = getEnvVar("REACT_APP_ENV");
